module.exports = __webpack_public_path__ + "static/media/rectangle-tblt-logged-in.9a295e00.svg";